export default {
  // Maximum snackbar notifications on top of each other
  maxNotificationsStack: window?._env_?.REACT_APP_MAX_NOTIFICATIONS_STACK || 3,
  // 10MB is the default limit.
  maxFileUploadSize: window?._env_?.REACT_APP_MAX_FILE_UPLOAD_SIZE || 10485760,
  fileExchangeDefaultEntity: window?._env_?.REACT_APP_FX_DEFAULT_ENTITY || 'RMC',
};
